import React from 'react';
import { formattedDuration } from 'utils/durations';
import type { TimeStyle } from '../datatable.types';
import { COLUMN_SIZE_SMALL } from './constants';
import HeaderWithMenu from './HeaderWithMenu';
import type { DatatableCellRenderer, DatatableColumnGetter } from './types';

export const getDurationColumn: DatatableColumnGetter<
  number,
  { label: string; timeStyle: TimeStyle; mandatory?: boolean }
> = (
  id: string,
  { label, timeStyle, mandatory } = { label: 'Time', timeStyle: 'traditional', mandatory: false }
) => ({
  id,
  header: props => <HeaderWithMenu {...props} label={label} sortLabelType="number" alignRight />,
  size: COLUMN_SIZE_SMALL,
  minSize: COLUMN_SIZE_SMALL,
  maxSize: COLUMN_SIZE_SMALL,
  enableResizing: false,
  meta: {
    numeric: true,
    alignRight: true,
    time: true,
    timeStyle: timeStyle,
    mandatory: mandatory,
  },
  cell: props => <DurationCell {...props} timeStyle={timeStyle} />,
});

export const DurationCell: DatatableCellRenderer<number, { timeStyle: TimeStyle }> = ({
  getValue,
  timeStyle,
}) => {
  const loggedMinutes = getValue();
  if (loggedMinutes === 0) {
    return <span>—</span>;
  }
  return <span>{formattedDuration(loggedMinutes, timeStyle)}</span>;
};
